import React from 'react';
import {styled} from '@mui/material/styles';

type Props = {
  onClick: () => void;
  children: React.ReactNode;
};

/**
 * This is a last resort solution.
 * Accordion header is now a button, so this is just temporary so we don't have button below button.
 */
export const SpanButton: React.FC<Props> = ({onClick, children}) => {
  const Wrapper = styled('div')(({theme}) => ({
    ...theme.typography.button,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1),
    borderRadius: 999,
    border: '1px solid #B1928F',
    textAlign: 'center',
    minWidth: '115px',
  }));

  return <Wrapper onClick={onClick}>{children}</Wrapper>;
};
